import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { cloneDeep } from 'lodash';
import { PlaceholderChildComponent } from '../../../layout/classes/placeholder-child-component.abstract';
import { modalResponse } from '../../../layout/constants/modal-responses.enum';

@Component({
  selector: 'simple-notes',
  templateUrl: './simple-notes.component.html',
  styleUrls: ['./simple-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SimpleNotesComponent extends PlaceholderChildComponent implements OnInit {

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  beforeClose(_modalResponse: modalResponse) {
    if (_modalResponse !== modalResponse.approve) {
      return;
    }
    return { value: this.payload.notes};
  }

}
